import React from 'react';
import { Divider, Typography } from '@mui/material';
import peyaj from '../../../../../images/Agri-info/crops/piaj_পেঁয়াজ.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const PeyajInfo = () => {

    // dynamic title
    useDocumentTitle("পেঁয়াজ");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h3"
                noWrap
                component="div"
            >
                পেঁয়াজ
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={peyaj} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text fw-bold">পুষ্টিমূল্যঃ </p>
                            <p className="card-text">এত প্রচুর ক্যালসিয়াম ও সামান্য ভিটামিন ‘সি’ আছে।</p>

                            <p className="card-text"><b>ভেষজ গুণঃ</b><br />
                                ১)         উত্তেজক হিসেবে কাজ করে<br />
                                ২)         প্রস্রাবের বেগ বাড়ায়<br />
                                ৩)         শ্বাসনালীর মিউকাস কমায়<br />
                                ৪)         ঋতুস্রাব বাড়ায়<br />
                                ৫)         হজমি নালার জ্বালা কমায়<br />
                                ৬)         রক্ত পরিশোধন করে<br />
                                ৭)         এ্যাজমা ও কোষ্ঠকাঠিন্য কমায়<br />
                                ৮)         পোকার কামড়ে বিশুদ্ধ মধুসহ প্রলেপ দিলে জ্বালা কমায়<br />
                                ৯)         কাঁচা পেঁয়াজের রস চুলের বৃদ্ধিতে সহায়ক।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>

                <p className="card-text fw-bold">ব্যবহারঃ   </p>
                <p className="card-text">তরকারীতে মসলা হিসেবে ব্যবহার ছাড়াও বিভিন্ন মুখরোচক খাবার তৈরিতে পেঁয়াজের ব্যবহার রয়েছে।</p>

                <p className="card-text fw-bold">উপযুক্ত জমি ও মাটিঃ     </p>
                <p className="card-text">উর্বর বেলে-দো-আঁশ মাটি পেঁয়াজ চাষের জন্য অতি উত্তম। বর্ষায় পেঁয়াজ চাষের জন্য উঁচু জমি দরকার যেখানে বৃষ্টির পানি জমেনা। জমিতে সেচ ও পানি নিকাশের ব্যবস্থা থাকতে হবে।</p>

                <p className="card-text fw-bold">জাত পরিচিতিঃ </p>
                <p className="card-text fw-bold">চারা তৈরিঃ  </p>
                <p className="card-text">৩  ও ১ মিটার আকারের প্রতি বীজতলার জন্য ২৫-৩০ গ্রাম বীজের প্রয়োজন হয়। পেঁয়াজ রবি ও খরিপ মৌসুমে চাষ করা যায়। খরিপ মৌসুমে চাষের জন্য জুলাই-আগষ্ট (শ্রাবণ-ভাদ্র) ও রবি মৌসুমে চাষের জন্য ফেব্রুয়ারী-মার্চ (মাঘ-ফাল্গুন) মাসে বীজ তলায় বীজ বপন করতে হয়। জমির আগাছা পরিষ্কার করে ভালভাবে চাষও মই দিয়ে ৩ত্ম১ মিটার আকারের বীজতলা করে এক সপ্তাহ রাখা হয়। বীজ বপনের পূর্বে আগের দিন সন্ধ্যায় বীজ ভিজিয়ে রেখে পরের দিন তুলে ১ ঘন্টা রৌদ্রে শুকিয়ে তারপর বীজতলায় বপন করতে হবে। বীজ বপনের পর ঝুরঝুরে মাটি দিয়ে বীজ ঢেকে দিতে হবে। বীজ বপনের পরদিন বেডে ছায়ার ব্যবস্থা করতে হবে। দিনের বেলা বীজতলা ঢেকে রাখতে হবে এবং রাত্রে খোলা রাখতে হবে। প্রয়োজনে ঝরনা দিয়ে পানি দিতে হবে।</p>

                <p className="card-text fw-bold">চারা রোপনঃ   </p>
                <p className="card-text">৫ টি চাষ ও মই দিয়ে জমি তৈরি করা হয়। ১৫   ও   ১০ সে.মি. দূরত্বে চারা রোপন করা হয়। বর্ষার সময় ১ মিটার চওড়া ও ১৫ সে.মি. উঁচু বেড তৈরি করে চারা রোপণ করা হয়। দুই বেডের মাঝে ৩০ সে.মি. চওড়া পানি নিকাশের নালা রাখা হয়। ৪০-৪৫ দিন বয়সের চারা লাগানোর উপযোগী হয়।</p>

                <p className="card-text fw-bold">সার ব্যবস্থাপনাঃ     </p>
                <p className="card-text">পেঁয়াজের জমিতে প্রতি হেক্টরে গোবর ৮-১০ টন, ইউরিয়া ২৫০-২৭০ কেজি, টিএসপি ১৯০-২০ কেজি এবং ১৫০-১৭০ কেজি এমওপি সার প্রয়োগ করা হয়। জমি তৈরির সময় ১৬০-১৭০ কেজি ইউরিয়া ও বাকী সমুদয় সার মাটিতে মেশাতে হয়। চারা রোপনের ২০ দিন পর বাকী ইউরিয়া সার উপরি প্রয়োগ করা হয়।</p>
                <p>সেচ ও আগাছা ব্যবস্থাপনা জমিতে রসের অভাব থাকলে সেচ দিতে হবে। বর্ষা মৌসুমে যাতে বৃষ্টির পানি দাঁড়াতে না পারে সেজন্য নিকাশ নালা রাখতে হবে। জমি আগাছামুক্ত রাখতে হবে। সেচের পর জমি নিড়ানি দিয়ে আলগা করে দিতে হবে। পেঁয়াজের কন্দ উৎপাদনের ক্ষেত্রে ফুলের কুঁড়ি দেখামাত্র ভেঙ্গে দিতে হবে।</p>

                <p className="card-text fw-bold">পোকা</p>
                <p className="card-text"><b>পোকার নাম : </b>থ্রিপস</p>

                <p className="card-text fw-bold">ভূমিকা : </p>
                <p className="card-text">থ্রিপস ছোট আকারের পোকা বলে সহজে নজরে আসে না কিন্ত পাতার রস চুষে খায় বলে অধিক আক্রমণে পাতা শুকিয়ে গাছ মরে যায় ও ফলন কম হয়।</p>

                <p className="card-text fw-bold">পোকা চেনার উপায় : </p>
                <p className="card-text">স্ত্রী পোকা সরু,  হলুদাভ। পুরুষ গাঢ় বাদামী । বাচ্চা পোকা হলুদ অথবা সাদা । এদের পিঠের উপর লম্বা দাগ দেখা যায়।</p>

                <p className="card-text fw-bold">ক্ষতির নমুনা : </p>
                <p className="card-text">রস চুষে খায় বলে পাতা রূপালী রং ধারণ করে অথবা ক্ষুদ্রাকৃতির বাদামী দাগ বা ফোটা দেখা যায়। আক্রমণ বেশী হলে পাতা শুকিয়ে মরে যায়। কন্দ আকারে ছোট ও বিকৃত হয়।</p>
                <p><b>অনুকুল পরিবেশ : </b>বিকল্প পোষকের উপস্থি'তি।</p>

                <p className="card-text fw-bold">জীবন চক্র : </p>
                <p className="card-text">স্ত্রী পোকা পাতার কোষের মধ্যে ৪৫-৫০ টি ডিম পাড়ে। ৫-১০ দিনে ডিম হতে নিম্ফ (বাচ্চা) বের হয়। নিম্ফ ১৫-৩০ দিনে দুটি ধাপ অতিক্রম করে । প্রথম ধাপে খাদ্য গ্রহণ করে  এবং দ্বিতীয় ধাপে খাদ্য গ্রহণ না করে মাটিতে থাকে । এরা বছরে ৮ বার বংশ বিস্তার করে এবং স্ত্রী পোকা পুরুষ পোকার সাথে মিলন ছাড়াই বাচ্চা দিতে সক্ষম ।</p>

                <p className="card-text fw-bold">ব্যবসস্থাপনা : </p>
                <p className="card-text">সাদা রংয়ের আঠালো ফাঁদ ব্যবহার ক্ষেতে মাকড়সার সংখ্যা বৃদ্ধি করে এ পোকা দমন করা যায়। অনুমোদিত কীটনাশক নির্ধারিত মাত্রায় প্রয়োগ করতে হবে।</p>

                <p className="card-text fw-bold">রোগ ব্যবস্থাপনা</p>
                <p><b>রোগের নাম : </b>পার্পল বস্নচ / বস্নাইট</p>
                <p className="card-text fw-bold">ভূমিকা : </p>
                <p className="card-text">এ রোগ পেঁয়াজের সবচেয়ে বেশি ক্ষতি করে। যে কোন বয়সে গাছের পাতা ও কান্ড আক্রান্ত হয়। অধিক আক্রমনে পেঁয়াজে ফুল আসে না ও ফসল কম হয়। আক্রান্ত বীজ বেশিদিন গুদামে রাখা যায়না । বাজার মূল্য কমে যায়।</p>

                <p className="card-text fw-bold">রোগের কারণ : </p>
                <p className="card-text">অল্টারনারিয়া পোরি ও স্টেমফাইলিয়াম বট্রাইওসাম নামক ছত্রাকদ্বয় দ্বারা এ রোগ হয়ে থাকে।</p>

                <p className="card-text fw-bold">ক্ষতির নমুনা : </p>
                <p className="card-text">কান্ডে প্রথমে ক্ষুদ্র ক্ষুদ্র পানি ভেজা হালকা বেগুনী রংয়ের দাগের সৃষ্টি হয়। দাগগুলি বৃদ্ধি পেয়ে বড় দাগে পরিণত হয় এবং আক্রান্ত  স্থান খড়ের মত হয়ে শুকিয়ে যায়।</p>
                <p>- আক্রান্ত পাতা ক্রমান্বয়ে উপরের দিক হতে মরতে শুরু করে।<br />
                    - পাতা বা কান্ডের গোড়ায় আক্রান্ত স্থানের দাগ বৃদ্ধি পেয়ে হঠাৎ পাতা বা বীজবাহী  কান্ড ভেঙ্গে পড়ে এতে বীজ অপুষ্ট হয় ও ফলন কম হয়।</p>
                <p><b>অনুকুল পরিবেশ : </b>বৃষ্টিপাত হলে এ রোগ দ্রত বিস্তার লাভ করে।</p>
                <p><b>বিস্তার : </b>আক্রান্ত বীজ, গাছের পরিত্যাক্ত অংশ ও বায়ুর মাধ্যমে এ রোগ বিস্তার লাভ করে।</p>

                <p className="card-text fw-bold">ব্যবস্থাপনা :</p>
                <p className="card-text">
                    - রোগ প্রতিরোধী বা সহনশীল জাত ব্যবহার<br />
                    - রোগমুক্ত বীজ ব্যবহার<br />
                    - ফসল পর্যায় অনুসরন করা অর্থ্যাৎ একই জমিতে পর পর কমপক্ষে ৪ বছর পেঁয়াজ না করা<br />
                    - পেঁয়াজ গাছের পরিত্যাক্ত অংশ, আগাছা ধ্বংশ করা<br />
                    - অনুমোদিত ছত্রাক নাশক নির্ধারিত মাত্রায় প্রয়োগ করা ।  </p>

                <p><b>কান্ড  পঁচা রোগ</b></p>

                <p><b>রোগের নাম :</b> কান্ড পঁচা<br />  <b>রোগের কারণ :</b> স্ক্লেরোসিয়াম রলফসি ও ফিউজারিয়াম নামক ছত্রাক দ্ধারা এ রোগ হয়।</p>

                <p className="card-text fw-bold">ভূমিকা :  </p>
                <p className="card-text">যে কোন বয়সে গাছ এ রোগে আক্রান্ত হতে পারে। কন্দ ও শিকড়ে এর আক্রমণ দেখা যায়। আক্রান্ত কন্দে পচন ধরে এবং আক্রান্ত কন্দ গুদামজাত করে বেশী দিন রাখা যায় না।</p>

                <p className="card-text fw-bold">ক্ষতির নমুনা : </p>
                <p className="card-text">আক্রান্ত গাছের পাতা হলদে হয়ে যায় ও ঢলে পড়ে ।</p>
                <p>- টান দিলে আক্রান্ত গাছ খুব সহজে মাটি থেকে কন্দসহ ( পেঁয়াজ) উঠে আসে।<br />- আক্রান্ত স্থানে সাদা সাদা ছত্রাক এবং বাদামী বর্ণের গোলাকার ছত্রাক গুটিকা (স্ক্লেরোসিয়াম ) দেখা যায়।</p>

                <p className="card-text fw-bold">অনুকুল পরিবেশ : </p>
                <p className="card-text">অধিক তাপ ও আর্দ্রতা পূর্ণ মাটিতে এ রোগ দ্রত বিস্তার লাভ করে। ক্ষেতে সেচ দিলেও এ রোগ বৃদ্ধি পায়।</p>

                <p className="card-text fw-bold">অনুকুল পরিবেশ : </p>
                <p className="card-text">বিস্তার : এ  রোগের জীবাণু মাটিতে বসবাস করে বিধায় সেচের পানির মাধ্যমে ও মাটিতে আন্তঃ পরিচর্যার সময় কাজের হাতিয়ারের মাধ্যমে এ রোগের বিস্তার হয়।</p>

                <p className="card-text fw-bold">ব্যবস্থাপনা :</p>
                <p className="card-text">
                    - আক্রান্ত গাছ তুলে ধ্বংশ করতে হবে।<br />
                    - মাটি সব সময় স্যাঁত স্যাঁতে রাখা যাবে না।<br />
                    - আক্রান্ত জমিতে প্রতি বছর পেঁয়াজ /রসুন চাষ করা যাবে না।<br />
                    - অনুমোদিত ছত্রাক নাশক নির্ধারিত মাত্রায় প্রয়োগ করতে হবে।</p>

                <p className="card-text fw-bold">ফসল সংগ্রহঃ   </p>
                <p className="card-text">সাধারণতঃ বর্ষা মৌসুমে ৩৫-৪৫ দিন এবং রবি মৌসুমে ৪০-৫৫ দিনের মধ্যে পেঁয়াজ তোলার উপযুক্ত হয়। রবি মৌসুমে পেঁয়াজের পাতা মরে গেলে (গলা চিকন হলে) গাছ সমেত পেঁয়াজ তুলে এনে পাতা শুকিয়ে মরা পাতা কেটে সংরক্ষণ করা হয়। প্রতি হেক্টরে ফলন রবিতে ১২-১৬ টন ও খরিপ ১০-১২ টন।</p>

            </div>
        </div >


    );
};

export default PeyajInfo;